URL = '/customer/conversations/%CONVERSATION_ID%/conversation_attributes'

class Customer.ConversationAttribute extends Backbone.Model
  urlRoot: -> URL.replace('%CONVERSATION_ID%', @get('conversation_id'))

  get: (key) =>
    if key == 'definition'
      window.definitionsRepository.get_definition_for_code(@getCode())
    else
      super(key)

  isRequired: =>
    _.findWhere(@get('definition').get('validations'), validation_type: 'presence') != undefined

  toJSON: =>
    json = super()
    json.definition = window.definitionsRepository.get_definition_for_code(@getCode()).toJSON()
    json

  hasCode: (name) =>
    @getCode() == name

  getCode: =>
    @get('code')

  getValue: =>
    @get('value')

  validate: =>
    @_clearErrors()
    @_isFilled() || @_onValidationError()

  canUpdate: =>
    @_clearErrors()
    @_canUpdate() || @_onValidationError()

  getErrors: =>
    @get('definition').getErrors()

  _isFilled: =>
    @get('definition').isFilled(@getValue())

  _canUpdate: =>
    @get('definition').isValid(@getValue())

  _onValidationError: =>
    @error = true
    @trigger('attribute:validation:error')
    false

  _clearErrors: =>
    @get('definition').clearErrors()
    @error = false


class Customer.ConversationAttributeCollection extends Backbone.Collection
  model: Customer.ConversationAttribute
  url: -> URL.replace('%CONVERSATION_ID%', @conversation_id)

  initialize: (conversation_id, options = {}) ->
    @conversation_id = conversation_id
    super([], options)

  parse: (response) ->
    @alreadyLoaded = true
    @backupAttributes = response.attributes
    super(response.attributes)

  rollBackModels: ->
    @_clearErrors()
    count = 0
    _.each(@backupAttributes, ({value, definition}) =>
      @models[count].set({value})
      @models[count].get('definition').set(definition)
      @models[count].changed = null
      count += 1
    )

  isAlreadyLoaded: ->
    !!@alreadyLoaded

  canUpdate: =>
    _.every(_.map(@_getChangedAttributes(), (attribute) -> attribute.canUpdate()))

  saveChanges: ({added, deleted}) ->
    $.ajax
      url: @url() + '/update',
      type: 'POST'
      contentType: 'application/json'
      data: JSON.stringify
        conversation_attributes_definitions:
          added: added
          deleted: deleted
      success: (response) =>
        _.each(@models, (model) -> model.changed = null)
        @backupAttributes = response.attributes
        @reset(response.attributes)
        @trigger('conversation:attributes:update')
      error: (jqXHR, textStatus, errorThrown) -> # Added parameters here
        console.error("AJAX Error:", textStatus, errorThrown, jqXHR)
        showError(I18n.t('customer.dashboard.conversations.attributes.error'))

  _getChangedAttributes: =>
    @filter (model) -> model.hasChanged('value')

  _getChangedValues: ->
    models = @filter (model) -> model.hasChanged('value')
    _.map models, (model) ->
      definition_code: model.get('definition').get('code')
      value: model.get('value')

  _prepareModel: (model, options) ->
    model.conversation_id = @conversation_id
    super(model, options)

  validateFieldsAreFilled: (fields) =>
    message = null
    success = @isAlreadyLoaded() &&
      _.every(_.map(fields, (field) =>
        unless @any((ownField) -> ownField.hasCode(field))
          message = "custom conversation attribute with code: #{field} is missing, please complete it in order to continue"
          return false
        @any((ownField) ->
          ownField.hasCode(field) &&
          ownField.validate()
        )
      ))
    message = I18n.t('user_profiles.custom_attributes.fill_mandatory_fields') if !success && !message
    {success, message}

  _clearErrors: =>
    @each((attribute) -> attribute._clearErrors())
